import { initFancybox } from "../fancybox.ts";

import "./review-widget/reviewScore.css";
import "./review.css";

function initReview() {
  initFancybox();
}

export { initReview };
